import React from "react";
import getProfileLabel from "../../genericFunctions/getProfileLabel";

const PrintHobbiesPage = (props) => {
  const hobbies = props.hobbies;
  const label = (key) => getProfileLabel(props.language, key);

  return (
    <div
      className="print-font"
      style={{
        paddingRight: "15px",
        borderTop: "1px solid #fff",
        marginTop: "40px",
        maxWidth: "100%",
      }}
    >
      <h3
        style={{
          marginBottom: "10px",
          background: "#ffffff",
        }}
      >
        {label("hobbies")}
        <div className="print-border"></div>
      </h3>
      <div>
        {hobbies === undefined || hobbies.length <= 0 ? (
          <p style={{ marginBottom: "0px", fontSize: "1.25rem" }}>
            {label("noHobbies")}
          </p>
        ) : (
          hobbies.map((hobby) => {
            return (
              <p
                style={{ marginBottom: "5px", fontSize: "1.25rem" }}
                key={hobby._id}
              >
                {" "}
                {hobby.name}{" "}
              </p>
            );
          })
        )}
      </div>
    </div>
  );
};
export default PrintHobbiesPage;
